/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { OrganizationByInn } from './OrganizationByInn'
import {
  OrganizationByInnFromJSON,
  OrganizationByInnFromJSONTyped,
  OrganizationByInnToJSON,
} from './OrganizationByInn'

/**
 *
 * @export
 * @interface GetOrgByInn200Response
 */
export interface GetOrgByInn200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetOrgByInn200Response
   */
  status: boolean
  /**
   *
   * @type {Array<OrganizationByInn>}
   * @memberof GetOrgByInn200Response
   */
  data: Array<OrganizationByInn>
}

/**
 * Check if a given object implements the GetOrgByInn200Response interface.
 */
export function instanceOfGetOrgByInn200Response(
  value: object
): value is GetOrgByInn200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetOrgByInn200ResponseFromJSON(
  json: any
): GetOrgByInn200Response {
  return GetOrgByInn200ResponseFromJSONTyped(json, false)
}

export function GetOrgByInn200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrgByInn200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(OrganizationByInnFromJSON),
  }
}

export function GetOrgByInn200ResponseToJSON(
  value?: GetOrgByInn200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(OrganizationByInnToJSON),
  }
}
